@if (headerRow) { <ng-container *ngTemplateOutlet="headerRow.templateRef"></ng-container>} @if (data$ | async; as data){
<ng-container *ngFor="let item of data; let rowIndex = index; trackBy: trackByDataFn">
  <ng-container *ngFor="let row of rows; trackBy: trackByRowFn">
    <bosch-ui-table-row
      *ngTemplateOutlet="
        row.templateRef;
        context: {
          $implicit: item,
          rowIndex: rowIndex,
          isFirst: rowIndex === 0,
          isLast: rowIndex === data.length - 1
        }
      "
    ></bosch-ui-table-row>
  </ng-container> </ng-container
>}
